import { call, put, takeLatest } from "redux-saga/effects";
import { TreatmentPlanTemplatesAPI } from "../../../api/treatmentPlansAPI";
import { ToastType } from "../../../utils/interfaces";
import {
  DELETE_MEDICATION_TEMPLATE_ERROR,
  DELETE_MEDICATION_TEMPLATE_REQUEST,
  DELETE_MEDICATION_TEMPLATE_SUCCESS,
  GET_MEDICATION_TEMPLATES_REQUEST,
  SET_TOAST
} from "../../actions";

function* workerDeleteMedicationTemplate(action: {
  type: string;
  payload: {
    id: string;
    navigate: Function;
    shouldLoadList: boolean;
    searchString: string;
  };
}): Generator<any> {
  try {
    const { id, navigate, shouldLoadList, searchString } = action.payload;
    yield call(TreatmentPlanTemplatesAPI.deleteMedicationTemplate, id);
    yield put({
      type: DELETE_MEDICATION_TEMPLATE_SUCCESS
    });
    if (navigate) {
      navigate("/medication-templates");
    }
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Medication template was successfully deleted",
        type: ToastType.SUCCESS,
      }
    });
    if (shouldLoadList) {
      yield put({
        type: GET_MEDICATION_TEMPLATES_REQUEST,
        payload: { searchString }
      });
    }
  } catch (error: any) {
    yield put({
      type: DELETE_MEDICATION_TEMPLATE_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherDeleteMedicationTemplate() {
  yield takeLatest(DELETE_MEDICATION_TEMPLATE_REQUEST, workerDeleteMedicationTemplate);
}
